import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e322913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-top":"12px"} }
const _hoisted_2 = { class: "contract-list-tab" }

import { computed, ref, onMounted } from 'vue';
import {
  XrkTable,
  XrkTableRef,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  BaseButton,
  useInputColumn,
  BaseToolTip,
  BaseTag,
  useCreateModal,
  BaseTabs,
  BaseTabPane,
  XrkMessageBox
} from 'xrk-components';

import {
  downloadContract,
  getContractType,
  getParticipatantOpt,
  listPage
} from '../data-source/apis';
import { useRoute, useRouter } from 'vue-router';
import { findDictLabel, removeEmpty } from '@/utils/formatter';
import {
  CONTRACT_STATUS,
  CONTRACT_TYPE,
  ContractStatus,
  ContractType,
  SIGH_STATUS,
  SIGN_TYPE,
  SignType
} from '../constants';
import CompanyInfoDialog from '../components/company-info-dialog.vue';
import { signContract } from '@/common/data-source/common/apis';
import { file, formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-list',
  setup(__props) {

const router = useRouter();

// table Ref
const xrkTableRef = ref<XrkTableRef>(null);

const contractType = ref(null);
const contractTypes = ref([]);
const route = useRoute();
const roleType = computed(() => route.meta?.role);

const textOverflow = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

let partOpt = [];

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => ({
  searchColumns: [
    useInputColumn({
      prop: 'contractName',
      type: 'input',
      label: '合同名称',
      config: {
        placeholder: '请输入合同名称',
        maxlength: 15
      }
    }),
    useSelectColumn({
      prop: 'participantB',
      label: '签署方',
      config: {
        placeholder: '请选择签署方',
        clearable: true,
        remoteMethod: async () => {
          const { data } = await getParticipatantOpt({
            type: contractType.value,
            roleType: roleType.value
          });
          partOpt = data;
          return { data: { list: data } };
        },
        labelKey: 'name',
        valueKey: 'id'
      }
    }),
    useInputColumn({
      prop: 'secondPartyName',
      type: 'input',
      label: '签署方名称',
      config: {
        placeholder: '请输入签署方名称',
        maxlength: 50
      }
    }),
    useSelectColumn({
      prop: 'lineType',
      label: '签约方式',
      config: {
        placeholder: '请选择签约方式',
        clearable: true,
        options: SIGN_TYPE
      }
    }),
    useSelectColumn({
      prop: 'signingStatus',
      label: '合同状态',
      config: {
        placeholder: '请选择合同状态',
        clearable: true,
        options: CONTRACT_STATUS
      }
    })
  ]
}));

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '合同编号',
      prop: 'code',
      minWidth: 300
    }),
    useTableColumn({
      label: '合同名称',
      prop: 'contractName',
      minWidth: 200
    }),
    useTableColumn({
      label: '甲方',
      showOverflowTooltip: false,
      width: 248,
      prop: 'firstPartyName',
      render: ({ row, cellValue }) =>
        setPartyTableContent(row, cellValue, 'firstParty', row.firstStatus)
    }),
    useTableColumn({
      label: '乙方',
      width: 248,
      showOverflowTooltip: false,
      prop: 'secondPartyName',
      render: ({ row, cellValue }) =>
        setPartyTableContent(row, cellValue, 'secondParty', row.secondStatus)
    }),
    useTableColumn({
      label: '签约方式',
      prop: 'lineType',
      formatter: ({ cellValue }) => findDictLabel(SIGN_TYPE, +cellValue)
    }),
    useTableColumn({
      label: '合同状态',
      prop: 'signingStatus',
      width: 100,
      render: ({ cellValue }) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ marginRight: '4px' }}>
              {findDictLabel(CONTRACT_STATUS, +cellValue)}
            </div>
          </div>
        );
      }
    }),
    useTableColumn({
      label: '签署/上传时间',
      prop: 'signingFinishDt',
      formatter: ({ cellValue }) => formatter.date(cellValue),
      width: 180
    }),
    useTableColumn({
      label: '合同有效期',
      prop: 'validityEnd',
      // 4. 拒绝签署的显示“-”
      // 5. 已失效的显示失效时间
      // 1. 线上签署的显示合同模版规定的合同有效期显示
      // 2. 线下上传的显示上传时填写的有效期时间
      render: ({ row: { signingStatus, validityStart, validityEnd } }) => {
        if (signingStatus === ContractStatus.REJECTED) {
          return '-';
        }
        if (signingStatus === ContractStatus.EXPIRED) {
          return formatter.date(validityEnd);
        }
        return validityEnd === '长期' ? (
          '长期有效'
        ) : (
          <div>
            {[formatter.date(validityStart), formatter.date(validityEnd)].map(
              (item, ind) => (
                <div style={{ marginBottom: ind === 0 ? '4px' : 0 }}>
                  {item}
                </div>
              )
            )}
          </div>
        );
      },
      width: 180
    }),
    useTableColumn({
      prop: 'handle',
      label: '操作',
      fixed: 'right',
      width: '200px',
      render: ({
        row: {
          id,
          lineType,
          contractRenderUrl,
          loginType,
          firstStatus,
          secondStatus,
          signingStatus,
          contractName
        }
      }) => {
        return (
          <>
            <BaseButton
              type="text"
              // 线上 且 签署中或未签约的时候 置灰
              disabled={
                lineType === SignType.ONLINE &&
                (+signingStatus !== ContractStatus.COMPLETED ||
                  !contractRenderUrl)
              }
              onClick={() => {
                if (lineType === SignType.OFFLINE) {
                  router.push({
                    path: `/main/contract-mgmt/${route.meta.roleText}/view`,
                    query: { tab: contractType.value, id }
                  });
                  return;
                }
                // 线上签署的合同显示 e 签宝合同签署页面
                file.preview(contractRenderUrl);
              }}
            >
              查看
            </BaseButton>
            <BaseButton
              v-resource={[['签署合同']]}
              type="text"
              disabled={
                lineType === SignType.OFFLINE ||
                [ContractStatus.COMPLETED, ContractStatus.REJECTED].includes(
                  +loginType == 1 ? +firstStatus : +secondStatus
                )
              }
              onClick={async () => {
                const { data } = await signContract({ contractId: id });
                if (!data.currentUrl) {
                  xrkTableRef.value?.initCurrentList();
                  return;
                }
                window.open(data.currentUrl);
                XrkMessageBox.confirm(
                  `合同《${contractName}》是否已签约完成?`,
                  '提示',
                  {
                    confirmButtonText: '已完成',
                    cancelButtonText: '关闭'
                  }
                ).finally(() => {
                  xrkTableRef.value?.initCurrentList();
                });
              }}
            >
              签署
            </BaseButton>
            <BaseButton
              v-resource={[['下载']]}
              type="text"
              disabled={
                !(
                  [ContractStatus.COMPLETED, ContractStatus.EXPIRED].includes(
                    +signingStatus
                  ) && contractRenderUrl
                )
              }
              onClick={() => {
                downloadContract({ id });
              }}
            >
              下载
            </BaseButton>
          </>
        );
      }
    })
  ]
});

/** 甲乙方名称展示 */
const setPartyTableContent = (row, compName, partyType, signStatus) => {
  const { secondPartyId, firstPartyId, id, allianceUserType } = row;

  // 市场服务人员且乙方，为人名或个体户
  const showindividualName =
    partyType === 'secondParty' &&
    ContractType.MARKET_PERSON === contractType.value &&
    +allianceUserType !== 1;

  return (
    <>
      <div style={{ display: 'flex' }}>
        <BaseTag
          effect="plain"
          type={SIGH_STATUS[signStatus]?.type}
          style="margin-right: 8px;"
        >
          {SIGH_STATUS[signStatus]?.label}
        </BaseTag>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column'
          }}
        >
          <BaseToolTip effect="dark" content={compName} placement="top-start">
            <BaseButton
              link
              type="primary2"
              click={() => {
                const instant = useCreateModal(CompanyInfoDialog, {
                  id:
                    partyType === 'secondParty' ? secondPartyId : firstPartyId,
                  type: contractType.value,
                  // 只有市场服务人员且乙方，为人名或个体户，其他是公司
                  typeOfPartyAAndPartyB: partyType === 'secondParty' ? 2 : 1,
                  contractId: id,
                  onRemove: () => {
                    instant.remove();
                  }
                });
              }}
            >
              <p style={{ maxWidth: '140px', ...textOverflow }}>{compName}</p>
            </BaseButton>
          </BaseToolTip>
          {showindividualName && (
            <BaseToolTip
              effect="dark"
              content={row.individualName}
              placement="top-start"
            >
              <div style={{ maxWidth: '160px', ...textOverflow }}>
                {row.individualName}
              </div>
            </BaseToolTip>
          )}
        </div>
      </div>
    </>
  );
};

//获取当前登录者的合同类型
const getContractList = async () => {
  const types = (await getContractType({ roleType: roleType.value })) || [];
  if (types.length === 0) {
    return;
  }
  const queryTab = route.query.tab;
  if (queryTab && types.includes(+queryTab)) {
    contractType.value = +queryTab;
  } else {
    contractType.value = +types[0];
  }

  contractTypes.value = types.map(item => ({
    value: +item,
    label: findDictLabel(CONTRACT_TYPE, item)
  }));

  xrkTableRef.value?.initCurrentList?.();
};
onMounted(() => {
  getContractList();
});

const onTabChange = () => {
  xrkTableRef.value?.clearSearchValues();
  xrkTableRef.value?.initCurrentList();
};

/**
 * 获取列表
 */
const getListAjax = async params => {
  const { participantB } = params;
  if (participantB) {
    const partType = partOpt.find(
      item => +item.id === participantB
    )?.typeOfPartyAAndPartyB;
    delete params.participantB;
    params[`participant${+partType === 1 ? 'A' : 'B'}`] = participantB;
  }
  return listPage(
    removeEmpty({
      ...params,
      type: contractType.value,
      roleType: roleType.value
    })
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      "request-now": false,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, {
      tableTop: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (contractTypes.value?.length > 1)
            ? (_openBlock(), _createBlock(_unref(BaseTabs), {
                key: 0,
                modelValue: contractType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contractType).value = $event)),
                onTabChange: onTabChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractTypes.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                      label: item.label,
                      name: item.value,
                      key: item.value
                    }, null, 8, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})